export default Object.freeze({
  translations: {
    // Common
    common: {
      month: 'month',
      paid: 'Paid',
      free: 'Free',
      copyLink: 'Copy Link',
      linkCopied: 'Link copied',
      noSearchResults: 'No results found, try another search!',
      costMonth: '${{cost}}/month',
      all: 'All',
      categories: 'Categories',
      or: 'or',
      to: 'to',
      year: 'Year',
      here: 'here',
      you: 'You',
      backTo: 'Back to',
      readMore: 'read more',
      loggedInBy: 'Logged in: {{email}}',
      selectDay: 'Select a date...',
      selectPartner: 'Select partner ...',
      today: 'today',
      poweredBy: 'Powered by',
      status: 'Status',
      userId: 'User ID',
      email: 'Email',
      nickname: 'Nickname',
      menu: {
        overview: 'Overview',
        partnerAssets: 'Partner assets',
        reports: 'Reports',
        srreports: 'Streaming Card',
        srUsers: 'Users Info',
        srOverview: 'Overview',
        users: 'Users',
        profiles: 'Profiles',
        webhooks: 'SC Forms',
        streamingAdvice: 'Find My Bundle Tool',
        settings: 'Settings',
        transaction: 'Transaction',
        transactionOverview: 'Overview',
      },
      statuses: {
        registered: 'Registered',
        invited: 'Invited',
      },
      days: {
        shortName: {
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
          sun: 'Sun',
        },
      },
    },

    // Tooltip
    tooltip: {},

    // Buttons
    buttons: {
      close: 'Close',
      goBack: 'Go Back',
      goToHomePage: 'Go to Home page',
      backToLogin: 'Back to Login',
      logout: 'Logout',
      startHere: 'Start Here',
      next: 'Next',
      previous: 'Previous',
      yes: 'Yes',
      no: 'No',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      submit: 'Submit',
      remove: 'Remove',
      login: 'Login',
      apply: 'Apply',
      reset: 'Reset',
      edit: 'Edit',
      update: 'Update',
      showMore: 'Show more',
      showLess: 'Show less',
      seeMore: 'See more',
      send: 'Send',
      forgotPassword: 'Forgot password?',
      addUser: 'Add User',
      add: 'Add',
      cancel: 'Cancel',
      downloadReport: 'Download Report',
      showMoreDetails: 'Show more details',
      showLessDetails: 'Show less details',
      tempShowAllColumns: 'Temporarily show all columns',
      showSelectedColumns: 'Show only selected columns',
      uploadNewImage: 'Upload new image',
      backToAdmin: 'Back to Admin',
      activate: 'Activate',
      deactivate: 'Deactivate',
      reportingSchedule: 'Reporting schedule',
      downloadSCReport: 'Download SC report',
      SCOverview: 'SC Overview',
      SCAmountOverview: 'SC Amount Overview',
      backTo: 'Back to {{name}}',
      copyLink: 'Copy link',
      extend: 'Extend',
    },

    // Inputs
    inputs: {
      firstName: 'First Name',
      lastName: 'Last Name',
      username: 'Username',
      usernameHelp: 'We generated a username from your email, feel free to update it',
      yourAddress: 'Your Address',
      zipcode: 'ZIP Code',
      zipcodeEnter: 'Enter Your Zip Code*',
      other: 'Other',
      email: 'Email',
      emailPlaceholder: 'Enter your email address',
      emailAddress: 'Email Address',
      yourMailPlaceholder: 'Your email',
      title: 'Title',
      details: 'Details',
      fullName: 'Full Name',
      name: 'Name',
      addressPlaceholder: 'Enter your address',
      password: 'Password',
      passwordMinLengthPlaceholder: 'Enter {{length}} characters or more',
      passwordPlaceholder: 'Enter your password',
      confirmPassword: 'Password confirmation',
      price: 'Price',
      searchPlaceholder: 'Search',
      partner: 'Partner',
      allPeriod: 'All period',
      reportType: 'Report type',
      rewardType: 'Reward type',
      selectProgram: 'Select Program',
      selectDateRange: 'Select Date Range',
      rewards: 'Rewards',
      userRole: 'User role',
      account_id: 'Account #',
      account_idPlaceholder: 'Enter Your Account #',
      credit_amount: 'Credit Amount',
      credit_amountPlaceholder: 'Enter Credit Amount',
      reward_duration: 'Reward Duration',
      reward_durationPlaceholder: 'Enter Reward Duration',
      activation_period: 'Activation Period',
      activation_periodPlaceholder: 'Enter Activation Period',
      cancel_if_not_activated: 'Cancel if not activated',
      statuses: 'Statuses',
      rewardStatus: 'Reward Status',
      cohort_slug: 'Cohort slug',
      cohort_slugPlaceholder: 'Enter cohort slug',
      cohort_title: 'Cohort title',
      cohort_titlePlaceholder: 'Enter cohort title',
      // task 2879: SC Forms fields that only a mobile_plans reward sends
      plan: 'Plan',
      planPlaceholder: 'Please select a plan',
      line_ref: 'Line reference (optional)',
      line_refPlaceholder: 'Your own line or order reference',
      date_range_type: 'Date Range Type',
      switchPartner: 'Switch Partner',
      switchPartnerHelpText: 'Choose a partner to continue working in their workspace.',
    },

    // Validation
    validation: {
      emailRequired: 'Email is required!',
      emailNotValid: 'Enter a valid email address',
      minZipCodeLength: 'ZIP Code has to be at least {{length}} characters long!',
      maxZipCodeLength: "ZIP Code can't be at more than {{length}}!",
      shouldBeNumeric: 'Should be a number!',
      titleRequired: 'Title is required!',
      detailsRequired: 'Details is required!',
      fullNameRequired: 'Full Name is required!',
      nameRequired: 'Name is required!',
      firstNameRequired: 'First name is required!',
      lastNameRequired: 'Last name is required!',
      usernameRequired: 'Username is required!',
      zipcodeRequired: 'ZIP Code is required!',
      passwordRequired: 'Password is required!',
      passwordLength: 'Password has to be at least {{length}} characters long!',
      passwordDontMatch: "Passwords don't match!",
      emailsAlreadyTaken: 'Email already has been taken',
      userNameAlreadyTaken: 'Username already has been taken',
      priceRequired: 'Price is required!',
      priceMaxLength: "The price can't be greater than {{max_price}}!",
      partnerRequired: 'Partner is required!',
      userRoleRequired: 'User role is required!',
      accountIdRequired: 'Account # is required!',
      creditAmountRequired: 'Credit amount is required!',
      dateRequired: 'Date is required!',
      fieldRequired: 'Field is required!',
    },

    // Notification
    notification: {
      successfullyAddedEmail: 'Email sent!',
      autoLogin: 'We have recognized you as a registered user and logged you in',
      resetPassSuccess: 'A password recovery email has been sent to your email address.',
      resetPassUpdateSuccess: 'Password was successfully changed.',
      profileUpdateSuccess: 'Profile data was successfully updated.',
      inviteSentSuccess: 'Invite was successfully sent.',
      updateUserSuccess: 'User was successfully updated.',
      webhookSentSuccess: 'Webhook was successfully sent.',
      partnerSettingsUpdateSuccess: 'Partner settings were successfully updated.',
      deactivateUserSuccess: 'User was successfully deactivated.',
      activateUserSuccess: 'User was successfully activated.',
      saveSettingsSuccess: 'Settings was successfully saved.',
      transferRequestSentSuccess: 'Transfer request was successfully sent.',
      inviteExtended: 'Invite extended — new activation deadline {{date}}',
    },

    // Alerts
    alerts: {
      storageUnavailable:
        'Unfortunately our recommendation tools don’t work with third-party cookies blocked, please try another browser or turn off incognito mode.',
      deactivateUser: 'Are you sure that you want to deactivate {{name}}?',
    },

    loadings: {
      saveSettings: 'Settings are saving, please wait',
    },

    // Breadcrumbs
    breadcrumbs: {
      'sr-reports': 'Streaming Card',
    },

    // ** PAGES

    // NotFound Page
    notFound: {
      title: '404',
      subTitle: 'Page not found',
    },

    // Login Page
    signIn: {
      title: 'Login',
    },

    // Reset Password Page
    resetPassword: {
      title: 'Reset Password',
      subtitle: `We are here to help you to recover your password. \n
        Enter the email address you used when you joined \n
        and we’ll send you instructions to reset your password`,
    },

    // Update Password Page
    updatePassword: {
      title: 'Update Password',
      createTitle: 'Create Password',
    },

    // Reports Page
    reports: {
      title: 'Reports',
      emptyMessage: 'No Data Available for This Time Period',
      manageColumns: 'Manage columns',
    },

    // SR Reports Page
    srReports: {
      title: 'Streaming Choice Reports',
      emptyMessage: 'No Data Available for This Filters',
    },

    srOverview: {
      title: 'Overview',
      emptyMessage: 'No Data Available for This Report',
    },

    // SR User Details Page
    srUserDetails: {
      title: 'SC User Details',
      backTo: 'SC Users',
      sRewards: {
        title: 'Streaming Rewards',
      },
      buttons: {
        moveToTest: 'Move to test',
      },
      table: {
        requestTransfer: 'Request Transfer',
      },
    },

    // SR Invited Users Page
    srInvitedUsers: {
      title: 'Users Info',
      emptyMessage: 'No Data Available for This Filters',
      searchPlaceholder: 'Search users by Account ID or email...',
      inviteStatus: {
        active: 'Active',
        expired: 'Expired',
        claimed: 'Claimed',
        cancelled: 'Cancelled',
      },
      extendConfirm:
        'Extend the invite for {{email}}? The activation window will restart from today.',
    },

    // SR Transaction Overview Page
    srTransactionOverview: {
      title: 'Transaction Overview',
      emptyMessage: 'No Data Available for This Filters',
    },

    // SR Report Page
    srReport: {
      title: 'SR Report',
      emptyMessage: 'No data available for the selected filters',
    },

    // Users Page
    users: {
      title: 'Users',
      emptyMessage: 'You have not created any users yet.',
    },

    // Profiles Page
    profiles: {
      title: 'Profiles',
      emptyMessage: 'You have not created any users yet.',
    },

    // Overview Page
    overview: {
      title: 'Overview',
      emptyMessage: 'You have not statistics yet.',
    },

    // Partner Assets Page
    partnerAssets: {
      title: 'Partner assets',
      streamingChoiceSupport: {
        title: 'Streaming Choice Customer Support',
        emptyTitle: 'No streaming choice rewards found.',
        loading: 'Loading streaming choice rewards…',
        rewardLink: 'View reward',
        callInProcess: {
          title: 'Process for when a customer calls in asking for their reward',
          dashboardCheckPrefix: 'Check the Dashboard under the ',
          peoplesTab: "People's Tab",
          dashboardCheckSuffix:
            ', by inputting their email address. If there is information listed, then that customer is in our system and eligible for the reward.',
          redemptionIntro: 'All you need to do is give the redemption page link:',
          noRecordPrefix: 'If there is no information under the ',
          noRecordMiddle:
            ', then that means MyBundle did not receive an email address to activate that user for a reward. In this scenario only, simply go to the ',
          formsLink: 'Forms section',
          noRecordSuffix: 'and distribute a reward or add the customer to the next SFTP list.',
        },
        copyEmail: 'Copy Email',
        emailCopied: 'Email copied to clipboard',
        sampleEmail: {
          title: "Sample email to send to customers who can't find the original email:",
          body: `Hi,

To redeem your choice of Streaming Services, just click the link below and follow the instructions. Make sure to use the email address associated with {{partnerName}}.

{{redemptionUrl}}

After logging in, you will be able to access your virtual credit card to pay for your choice of 1 service.

Already streaming? You can always use the card to pay for your current subscription. Just swap out your current form of payment with your Streaming Choice Card from {{partnerName}}.`,
        },
      },
    },

    // Webhooks Page
    webhooks: {
      title: 'Streaming Choice Forms',
      rewardPlaceholder: 'Please select a reward',
      formAdd: {
        title: 'Add Credits for Customer',
        description: 'Invites a user to this reward.',
      },
      formUpdate: {
        title: 'Set Credits for Customer',
        description: "Replaces the customer's credit balance with the selected amount.",
      },
      formCancel: {
        title: 'Cancel Credits for Customer',
        description: "Cancels a user's active reward or invitation.",
      },
    },

    // Settings page
    settings: {
      tabs: {
        item1: 'Customization',
        item2: 'Scheduled emails',
      },
      scheduledEmails: {
        emptyState: 'No scheduled emails yet',
      },
    },

    // ** COMPONENTS

    // Pagination
    pagination: {
      rowsPerPage: 'Rows per page',
      previousPage: 'Previous Page',
      nextPage: 'Next Page',
      of: 'of',
    },

    // Table
    table: {
      userId: 'User Id',
      email: 'Email',
      status: 'Status',
      partner: 'Partner',
      emptySearchResults: 'We fount 0 results for “{{searchString}}”. Please try another search',
      title: 'Title',
      description: 'Description',
      role: 'Role',
      reportTitle: 'Report title',
      period: 'Period',
      reward: 'Reward',
      rewardType: 'Reward Type',
      date: 'Date',
      info: 'Information',
      amount: 'Amount',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      nickname: 'Nickname',
      accountId: 'Account Id',
      invited: 'Invited',
      slug: 'Slug',
      action: 'Action',
    },

    // Payment History Table
    paymentHistoryTable: {
      title: 'Payment History',
      emptyMessage: 'No payments history yet',
    },

    // Add user dialog
    addUserDialog: {
      title: 'Add user',
    },

    // Edit user dialog
    editUserDialog: {
      title: 'Edit user',
    },

    // Schedule report dialog
    scheduleReportDialog: {
      title: 'Create a scheduled report',
    },
  },
});
